import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAccess } from '../../services/pocApi';

// The caller's administrator flag (existing App.ADMIN role), read once from
// /poc-reference/access. It only decides which controls are shown: every
// administrator action is still authorized by the backend. Until the answer
// arrives, or if the check fails, the user is treated as a non-administrator.

const PocAccessContext = createContext({ isAdmin: false, checked: false });

export function PocAccessProvider({ children }) {
    const [access, setAccess] = useState({ isAdmin: false, checked: false });

    useEffect(() => {
        const controller = new AbortController();
        getAccess(controller.signal)
            .then((body) => setAccess({ isAdmin: body.is_admin === true, checked: true }))
            .catch(() => {
                if (!controller.signal.aborted) setAccess({ isAdmin: false, checked: true });
            });
        return () => controller.abort();
    }, []);

    return <PocAccessContext.Provider value={access}>{children}</PocAccessContext.Provider>;
}

export const usePocAccess = () => useContext(PocAccessContext);
